import React from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { useTranslation } from 'react-i18next';
export var ShiftDetailsModalFooterButton = function (_a) {
    var dataTestId = _a.dataTestId, onClick = _a.onClick, label = _a.label;
    var t = useTranslation().t;
    return (React.createElement(Button, { onClick: onClick, "aria-label": label, "alt-text": t('shift_management_common_button', {
            label: label
        }), dataTestId: dataTestId, variant: ButtonVariant.Secondary }, label));
};
